import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const useLiveHubEnabled = () =>
    useJurisdictionStore(state => state.jurisdictionSettings?.productConfig?.settings?.live_hub_enabled ?? false);
